import BaseModule from "~/vuex/modules/base-module";

let Customers = {...BaseModule};

Customers.state = function () {
    let state = BaseModule.state();

    state.endpoints['all'] = '/api/customer/';


    return state;
};

Customers.actions.searchOption = async function ({ commit, dispatch, getters, state, rootGetters }, data = {}) {
    if (!data.name && !data.email && !data.reference) {
        return false;
    }
    state.endpoints['search'] = '/api/customer/search';

    return dispatch('search', {
        term: data,
        includes: [],
        page: data.page,
        perPage: data.per_page,
    });
};

export default Customers;
